import { Tab, Tabs } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useRouter from '../../../utils/useRouter';
import { useSelector } from 'react-redux';
import { selectPinnedCount } from '../../../reducers/pinned.selectors';
import getCollectionTabs from './getCollectionTabs';
import { colors } from '../../../assets/styles/themes/variables';
import useResponsivePadding from '../../../utils/useResponsivePadding';

interface CollectionsTabsProps {
  activeTab: string;
  isNewDesignEnabled?: boolean;
}

const CollectionsTabs: React.FC<CollectionsTabsProps> = (props) => {
  const { activeTab } = props;
  const { t } = useTranslation();
  const { router } = useRouter();
  const tabs = getCollectionTabs(t);
  const contentPadding = useResponsivePadding();
  const pinnedCount = useSelector(selectPinnedCount);
  const pinnedTitle = pinnedCount ? `${tabs.pinned.label} • ${pinnedCount}` : tabs.pinned.label;

  const isNewDesignEnabled = !!props.isNewDesignEnabled;
  const baseTabSx = isNewDesignEnabled ? { textTransform: 'none' } : {};
  const pinnedTabSx = isNewDesignEnabled ? { ...baseTabSx, paddingLeft: 0 } : baseTabSx;

  return <Tabs
    value={activeTab}
    onChange={(_, newTab) => router.push({
      pathname: `/${newTab}`,
    })}
    variant='scrollable'
    scrollButtons='auto'
    sx={{
      paddingLeft: isNewDesignEnabled ? contentPadding : 0,
      backgroundColor: colors.neutral0,
    }}
  >
    <Tab value={tabs.pinned.id} label={pinnedTitle} sx={pinnedTabSx}/>
    <Tab value={tabs.ownCollections.id} label={tabs.ownCollections.label} sx={baseTabSx} />
    <Tab value={tabs.followedCollections.id} label={tabs.followedCollections.label} sx={baseTabSx} />
  </Tabs>;
};

export default CollectionsTabs;
